import React from 'react'
import {
    Tooltip,
    FormControl,
    Select,
    MenuItem,
    Box,
    Typography,
} from '@mui/material'
import { useFilterStore } from '../../stores/useFilterStore'

const ChangeFilterOverlapToggle = ({
    activeFilterCount,
    shouldDisableFilter,
    handleSwitchClick,
}) => {
    const recalculate = useFilterStore(state => state.recalculate)
    const highlight = useFilterStore(state => state.highlight)
    const filterMode = useFilterStore(state => state.filterMode)

    const currentOverlapMode =
        filterMode === 'recalculate'
            ? recalculate.overlapMode
            : highlight.overlapMode
    let title =
        activeFilterCount > 0 &&
        shouldDisableFilter &&
        'To change filter overlap mode clear all current filters '

    if (!title) {
        title = currentOverlapMode
            ? 'Showing statements that have all of the selected tags'
            : 'Showing statements that have any of the selected tags'
    }

    const isDisabled = activeFilterCount == 0 || shouldDisableFilter
    const value = shouldDisableFilter ? false : currentOverlapMode

    // Two mutually exclusive options, so any change is a flip — the existing
    // toggle handler (handleSwitchClick) stays correct without reading the value.
    return (
        <Tooltip title={title}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography
                    sx={{
                        fontSize: '14px',
                        fontWeight: 'bold',
                        color: isDisabled ? 'text.disabled' : 'text.primary',
                    }}
                >
                    statements must contain:
                </Typography>
                <FormControl size="small" disabled={isDisabled}>
                    <Select
                        value={value}
                        onChange={handleSwitchClick}
                        sx={{
                            fontSize: '14px',
                        }}
                    >
                        <MenuItem value={false} sx={{ fontSize: '14px' }}>
                            Any Tag (OR)
                        </MenuItem>
                        <MenuItem value={true} sx={{ fontSize: '14px' }}>
                            All Tags (AND)
                        </MenuItem>
                    </Select>
                </FormControl>
            </Box>
        </Tooltip>
    )
}

export default ChangeFilterOverlapToggle
